module.exports = __webpack_public_path__ + "static/media/help.528c99dc.svg";